import { useEffect } from 'react';

/**
 * Custom hook to handle Escape key press
 * Commonly used for closing modals, dropdowns, or other dismissible UI elements
 *
 * @param {Function} onEscape - Callback function to execute when Escape key is pressed
 */
export const useEscapeKey = (onEscape) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onEscape]);
};
